module.exports = __webpack_public_path__ + "static/media/ActivateUser.8e03f63f.png";